import React, { Component } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import Utils from '../Common/Utils.js';
import { Icon } from 'semantic-ui-react';


class PulseRateDisplay extends Component {

    display_value(){

        let unit = ""
        if (this.props.pulseRateDisplay.pulseRate !== "-"){
            unit = "bpm"
        }

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"1%"}}>
                    <Icon name='heartbeat' size='huge' color={Utils.getConvertedColor(this.props.pulseRateDisplay.color)}/>
                <Row>
                    <div>
                        <span id="row-measure-style" style={{color: this.props.pulseRateDisplay.color}}>{this.props.pulseRateDisplay.pulseRate}</span>
                        <span id="row-unit-style" style={{color: this.props.pulseRateDisplay.color}}>{unit}</span>                        
                    </div>                    
                </Row>
            </Row>
        )
    }

    //Display render
   	render(){

        return (
            <div>
                {(this.props.alert) ?
                    <Col style={{backgroundColor: "yellow"}}>
                        {this.display_value()}
                    </Col>
                    :
                    <Col>
                        {this.display_value()}
                    </Col>
                }
            </div>
        );
   	}
}
export default (PulseRateDisplay);